import { STATES } from "@/components/profile/options";

const STATE_NAME = Object.fromEntries(STATES);
export const stateName = (c) => STATE_NAME[c] || c;

export const targetStates = (p) => (p?.preferred_states || []).filter((s) => s !== "ANY");
export const remoteOnly = (p) => (p?.work_models || []).length === 1 && p.work_models[0] === "remote";

export const defaultSearch = (p) => ({
  query: p?.target_roles?.[0] || p?.headline || "software engineer",
  remote: remoteOnly(p),
  location: remoteOnly(p) ? "" : targetStates(p)[0] || "",
});

export const withLocation = (query, location) => (location ? `${query} in ${stateName(location)}` : query);
